export type PasswordStrength = "weak" | "medium" | "strong";

export interface PasswordStrengthResult {
  strength: PasswordStrength;
  score: number;
  feedback: string;
}

export function calculatePasswordStrength(password: string): PasswordStrengthResult {
  if (!password) {
    return {
      strength: "weak",
      score: 0,
      feedback: "Passwort erforderlich",
    };
  }

  let score = 0;
  const feedback: string[] = [];

  // Length check
  if (password.length >= 8) {
    score += 25;
  } else {
    feedback.push("Mindestens 8 Zeichen");
  }

  if (password.length >= 12) {
    score += 10;
  }

  // Lowercase letters
  if (/[a-z]/.test(password)) {
    score += 15;
  } else {
    feedback.push("Kleinbuchstaben");
  }

  // Uppercase letters
  if (/[A-Z]/.test(password)) {
    score += 15;
  } else {
    feedback.push("Großbuchstaben");
  }

  // Numbers
  if (/\d/.test(password)) {
    score += 15;
  } else {
    feedback.push("Zahlen");
  }

  // Special characters
  if (/[^a-zA-Z0-9]/.test(password)) {
    score += 20;
  } else {
    feedback.push("Sonderzeichen");
  }

  let strength: PasswordStrength;
  let feedbackText: string;

  if (score < 50) {
    strength = "weak";
    feedbackText = feedback.length > 0 
      ? `Schwach - Fügen Sie hinzu: ${feedback.join(", ")}`
      : "Schwaches Passwort";
  } else if (score < 80) {
    strength = "medium";
    feedbackText = feedback.length > 0
      ? `Mittel - Empfohlen: ${feedback.join(", ")}`
      : "Mittleres Passwort";
  } else {
    strength = "strong";
    feedbackText = "Starkes Passwort!";
  }

  return {
    strength,
    score,
    feedback: feedbackText,
  };
}
